// Must stay the first import: it patches BsDropdownModule.forRoot back in before any
// chunk that evaluates ngx-intl-tel-input can be loaded.
import './app/ngx-bootstrap-dropdown-shim';

import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

window.addEventListener('pageshow', (event: any) => {
  if (event.persisted) {
    window.history.go(-2);
  }
});

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], })
  .catch(err => console.error(err));
